import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { companiaCrear, companiaEditar } from "../../companias";
import { DataContext } from "../../../app/providers/DataContext";

import { Alert } from "../../../shared/ui";
import { CONST_RUTA_SUCURSALES_LISTAR } from "../../../app/constants/constants-rutas-codigos";
import { obtenerLocalStorage, obtenerNombreEImagenBase64 } from "../../../shared/utils/funciones";

import { CONST_KEY_USUARIO_AUTENTICADO } from "../../../app/constants/constanst-valores";

import Swal from 'sweetalert2';
import { usuarioObtenerCompaniasYSucursales } from "../../usuarios";

import { SucursalDatosGenerales } from "../components/SucursalDatosGenerales";
import { SucursalLogos } from "../components/SucursalLogos";
import { SucursalColores } from "../components/SucursalColores";

export const SucursalForm = () => {

    const { getDataSelector } = useContext(DataContext)
    const usuarioAutenticado = obtenerLocalStorage(CONST_KEY_USUARIO_AUTENTICADO);

    const [listaCompanias, setListaCompanias] = useState([])

    const [mensaje, setMensaje] = useState('')
    const [mostrar, setMostrar] = useState(false)
    const [tipoAlerta, setTipoAlerta] = useState<any>("")

    //Obtener la accion a partir de la url (agregar o editar)
    const location = useLocation();
    const pathname = location.pathname;

    const compania = location?.state || {}

    const accion = pathname.split("/").pop()

    // Obtener los valores de las variables CSS cuando el componente se monta
    const computedStyles = getComputedStyle(document.documentElement);

    // const logo_primario_guardado = compania?.estilo?.log_primario?.slice(24,) ? "data:image/jpeg;base64,/9j/" + compania?.estilo?.log_primario?.slice(24,) : ""

    // const logo_secundario_guardado = compania?.estilo?.log_secundario?.slice(24,) ? "data:image/jpeg;base64,/9j/" + compania?.estilo?.log_secundario?.slice(24,) : ""

    const logo_primario_guardado = compania?.estilo?.log_primario ? `data:image/png;base64,${compania?.estilo?.log_primario}` : ""
    const logo_secundario_guardado = compania?.estilo?.log_secundario ? `data:image/png;base64,${compania?.estilo?.log_secundario}` : ""

    const { register, handleSubmit, watch, formState: { errors }, setValue } = useForm({
        defaultValues: {
            CompCod: compania?.CompCod || "",
            CompPre: compania?.CompPre || "",
            CompRuc: compania?.CompRuc || "",
            CompRSoc: compania?.CompRSoc || "",
            CompNom: compania?.CompNom || "",
            CompDirec: compania?.CompDirec || "",
            CompCor: compania?.CompCor || "",
            CompTel: compania?.CompTel || "",

            CompPrinc: compania?.CompPrinc || "N",
            CompEst: compania?.CompEst || "A",
            // CompApDef: compania?.CompApDef || "N",

            CompPad: compania?.CompPad || "",
            CompTip: compania?.CompTip || "S",

            imagen_logo_principal: "",
            imagen_logo_secundario: "",
            color_fondo_menu_primario: compania?.estilo?.fondo_menu || computedStyles?.getPropertyValue('--color-fondo-menu-primario'),
            color_texto_nav_item: compania?.estilo?.text_opciones || computedStyles?.getPropertyValue('--color-texto-nav-item'),
            color_fondo_nav_item_activo: compania?.estilo?.fond_opc_activo || computedStyles?.getPropertyValue('--color-fondo-nav-item-activo'),
            color_texto_nav_item_activo: compania?.estilo?.text_opc_activo || computedStyles?.getPropertyValue('--color-texto-nav-item-activo'),

            color_button_primario: compania?.estilo?.boton_primario || computedStyles?.getPropertyValue('--color-button-primario'),
            color_button_primario_hover: compania?.estilo?.boton_primario_activo || computedStyles?.getPropertyValue('--color-button-primario-hover'),
            color_button_primario_texto: compania?.estilo?.text_boton_primario || computedStyles?.getPropertyValue('--color-button-primario-text'),

            color_button_secundario: compania?.estilo?.boton_secundario || computedStyles?.getPropertyValue('--color-button-secundario'),
            color_button_secundario_hover: compania?.estilo?.boton_secundario_activo || computedStyles?.getPropertyValue('--color-button-secundario-hover'),
            color_button_secundario_texto: compania?.estilo?.text_boton_secundario || computedStyles?.getPropertyValue('--color-button-secundario-text'),

        }
    });

    const onSubmitCrear = async (data) => {

        const imagen1 = await obtenerNombreEImagenBase64(data?.imagen_logo_principal[0])
        const imagen2 = await obtenerNombreEImagenBase64(data?.imagen_logo_secundario[0])

        const dataPOST = {
            // CompApDef: data?.CompApDef,
            CompEst: data?.CompEst,
            CompCod: data?.CompCod?.toUpperCase().trim() || "",
            CompPre: data?.CompPre?.toUpperCase().trim() || "",
            CompRuc: data?.CompRuc?.toUpperCase().trim() || "",
            CompRSoc: data?.CompRSoc?.toUpperCase().trim() || "",
            CompNom: data?.CompNom?.toUpperCase().trim() || "",
            CompDirec: data?.CompDirec?.toUpperCase().trim() || "",
            CompCor: data?.CompCor?.toUpperCase().trim() || "",
            CompTel: data?.CompTel?.toUpperCase().trim() || "",

            CompPad: data?.CompPad || "",
            CompTip: "S",

            log_primario: imagen1?.imagenBase64 || "",
            log_secundario: imagen2?.imagenBase64 || "",
            fondo_menu: data?.color_fondo_menu_primario || "",
            text_opciones: data?.color_texto_nav_item || "",
            fond_opc_activo: data?.color_fondo_nav_item_activo || "",
            text_opc_activo: data?.color_texto_nav_item_activo || "",
            boton_primario: data?.color_button_primario || "",
            boton_primario_activo: data?.color_button_primario_hover || "",
            text_boton_primario: data?.color_button_primario_texto || "",
            boton_secundario: data?.color_button_secundario || "",
            boton_secundario_activo: data?.color_button_secundario_hover || "",
            text_boton_secundario: data?.color_button_secundario_texto || "",
            token: usuarioAutenticado?.token
        }

        // Guardar los colores una vez se haya creado la compania
        // const colores = [
        //     { name: '--color-fondo-menu-primario', color: watch("color_fondo_menu_primario") },
        //     { name: '--color-texto-nav-item', color: watch("color_texto_nav_item") },
        //     { name: '--color-fondo-nav-item-activo', color: watch("color_fondo_nav_item_activo") },
        //     { name: '--color-texto-nav-item-activo', color: watch("color_texto_nav_item_activo") },
        //     { name: '--color-button-primario', color: watch("color_button_primario") },
        //     { name: '--color-button-primario-hover', color: watch("color_button_primario_hover") },
        //     { name: '--color-button-primario-text', color: watch("color_button_primario_texto") },
        //     { name: '--color-button-secundario', color: watch("color_button_secundario") },
        //     { name: '--color-button-secundario-hover', color: watch("color_button_secundario_hover") },
        //     { name: '--color-button-secundario-text', color: watch("color_button_secundario_texto") },
        // ];

        // cambiarColores(colores);

        const { status, message } = await companiaCrear(dataPOST)
        getDataSelector()
        setMostrar(true)
        setMensaje(message)
        if (status === 1) {
            setTipoAlerta("success")
            //   getCompaniasYSedesPorUsuario(usuarioAutenticado?.token)
            alertMensajeGuardado()

        } else {
            setTipoAlerta("warning")
        }

    }

    const onSubmitEditar = async (data) => {

        const imagen1 = await obtenerNombreEImagenBase64(data?.imagen_logo_principal[0])
        const imagen2 = await obtenerNombreEImagenBase64(data?.imagen_logo_secundario[0])

        const dataPOST = {
            // CompApDef: data?.CompApDef,
            CompEst: data?.CompEst,

            CompPre: data?.CompPre?.toUpperCase().trim() || "",
            CompRuc: data?.CompRuc?.toUpperCase().trim() || "",
            CompRSoc: data?.CompRSoc?.toUpperCase().trim() || "",
            CompNom: data?.CompNom?.toUpperCase().trim() || "",
            CompDirec: data?.CompDirec?.toUpperCase().trim() || "",
            CompCor: data?.CompCor?.toUpperCase().trim() || "",
            CompTel: data?.CompTel?.toUpperCase().trim() || "",

            CompCod: compania?.CompCod || "",
            compania_nuevo: data?.CompCod?.toUpperCase() || "",

            CompPad: data?.CompPad || "",
            CompTip: "S",

            log_primario: data?.imagen_logo_principal.length === 0 ? compania?.estilo?.log_primario : imagen1.imagenBase64,
            log_secundario: data?.imagen_logo_secundario.length === 0 ? compania?.estilo?.log_secundario : imagen2.imagenBase64,

            // log_primario: imagen1.imagenBase64 == null ? logo_primario_guardado : imagen1.imagenBase64,
            // log_secundario: imagen2.imagenBase64 == null ? logo_secundario_guardado : imagen2.imagenBase64,

            fondo_menu: data?.color_fondo_menu_primario || "",
            text_opciones: data?.color_texto_nav_item || "",
            fond_opc_activo: data?.color_fondo_nav_item_activo || "",
            text_opc_activo: data?.color_texto_nav_item_activo || "",
            boton_primario: data?.color_button_primario || "",
            boton_primario_activo: data?.color_button_primario_hover || "",
            text_boton_primario: data?.color_button_primario_texto || "",
            boton_secundario: data?.color_button_secundario || "",
            boton_secundario_activo: data?.color_button_secundario_hover || "",
            text_boton_secundario: data?.color_button_secundario_texto || "",

            token: usuarioAutenticado?.token
        }

        const { status, message } = await companiaEditar(dataPOST)
        getDataSelector()
        setMostrar(true)
        setMensaje(message)

        if (status === 1) {
            setTipoAlerta("success")
            //   getCompaniasYSedesPorUsuario(usuarioAutenticado?.token)
            alertMensajeGuardado()
        } else {
            setTipoAlerta("warning")
        }
    }

    const navigate = useNavigate();

    const cancelar = () => {
        navigate(CONST_RUTA_SUCURSALES_LISTAR)
    }


    // const [listaModulos, setListaModulos] = useState([])

    // const modulosBuscarActivos = async () => {

    //     const dataPOST = {
    //         Estado: "A",
    //         Superior: "",
    //         token: usuarioAutenticado?.token
    //     }

    //     const { modulos } = await modulosBuscar(dataPOST)
    //     setValue("CompApDef", compania?.CompApDef || "N")
    //     setListaModulos(modulos)
    // }

    const alertMensajeGuardado = () => {
        Swal.fire({
            icon: 'success',
            text: 'Para notar los cambios de los colores del sistema, vuelva a iniciar sesión',
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
        })
    }

    const [logoPrincipalBase64, setLogoPrincipalBase64] = useState(null);
    const [logoSecundarioBase64, setLogoSecundarioBase64] = useState(null);

    const obtenerCompaniasYSucursales = async () => {

        const dataPOST = {
            token: usuarioAutenticado?.token
        }

        const { companias } = await usuarioObtenerCompaniasYSucursales(dataPOST)
        setListaCompanias(companias)
        setValue("CompPad", compania?.CompPad || companias?.[0]?.id)

        return {
            companias,
        }
    }


    useEffect(() => {

        const cargarDatosIniciales = async () => {

            await obtenerCompaniasYSucursales()

            // await modulosBuscarActivos()
            //   await obtenerModulosPorCompania(watch("compania"))
        };

        cargarDatosIniciales();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // carga inicial (una sola vez al montar)


    return (
        <div className="p-3">
            <div className="container-fluid">
                <h3 className="tw-text-center tw-text-2xl tw-font-semibold tw-text-menu-primario tw-mt-1 tw-mb-4">Sucursal</h3>
                <div className="row mt-3">
                    <div className="col-12 col-lg-9 mx-auto mt-0">
                        {/* Formulario */}
                        <form id="CreateForm" onSubmit={accion === "agregar" ? handleSubmit(onSubmitCrear) : handleSubmit(onSubmitEditar)} className="row g-2 p-1">
                            <div className="row tw-rounded-2xl tw-bg-white tw-shadow-md tw-border tw-border-gray-100 p-1 pb-2 g-2">

                                <SucursalDatosGenerales
                                    register={register}
                                    errors={errors}
                                    watch={watch}
                                    accion={accion}
                                    listaCompanias={listaCompanias}
                                />

                                <SucursalLogos
                                    register={register}
                                    errors={errors}
                                    logo_primario_guardado={logo_primario_guardado}
                                    logo_secundario_guardado={logo_secundario_guardado}
                                    logoPrincipalBase64={logoPrincipalBase64}
                                    logoSecundarioBase64={logoSecundarioBase64}
                                    setLogoPrincipalBase64={setLogoPrincipalBase64}
                                    setLogoSecundarioBase64={setLogoSecundarioBase64}
                                />

                                <SucursalColores
                                    register={register}
                                    watch={watch}
                                    compania={compania}
                                    logo_primario_guardado={logo_primario_guardado}
                                    logoPrincipalBase64={logoPrincipalBase64}
                                />
                            </div>
                        </form>
                        {/* Fin formulario */}

                        <div className='mt-4 botones-accion text-center'>
                            {
                                accion === "agregar" && (
                                    <button className='btn btn-sm btn-primario col-md-2' type="submit" form="CreateForm" onClick={handleSubmit(onSubmitCrear)}>Guardar</button>
                                )
                            }
                            {
                                accion === "editar" && (
                                    <button className='btn btn-sm btn-primario col-md-2' type="submit" form="CreateForm" onClick={handleSubmit(onSubmitEditar)}>Guardar</button>
                                )
                            }
                            <button className='btn btn-sm btn-secundario col-md-2' onClick={cancelar}>Cancelar</button>
                        </div>
                    </div >
                </div>

                {
                    mostrar && (
                        <div className="row mt-4">
                            <div className="col-lg-6 mx-auto text-center alert-error">
                                <Alert severity={tipoAlerta}>{mensaje}</Alert>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}
